import request from './request'

// 获取评论留言列表
export function GetSourceListAsync(data){
    let url = "/api/Words/GetSourceListAsync";
    return request({
        url: url,
        method: 'post',
        dataType: 'json',
        data
    });
}

// 新增评论留言
export function CreateAsync(data) {
    let url= "/api/Words/CreateAsync";
    return request({
        url: url,
        method: 'post',
        dataType: 'json',
        data
    });
    
}

// 删除评论留言 /api/Words/DeleteAsync
export function DeleteAsync(data) {
    let url= "/api/Words/DeleteAsync";
    return request({
        url: url,
        method: 'post',
        dataType: 'json',
        data
    });
    
}
// 查询评论回复列表/api/Words/GetAnswerListAsync
export function MoreAnswer(data) {
    let url= "/api/Words/GetAnswerListAsync";
    return request({
        url: url,
        method: 'post',
        dataType: 'json',
        data
    });
    
}


// WEBPACK FOOTER //
// ./src/assets/js/modules/wordsAp.js